import * as React from 'react';
import { styled } from 'styled-components';

import { ListItem, SpaceBetween, tk, Typography, Icon } from '@sunwebgroup/ui-components';

import { CardControl, TravelRoute, CardTrailing, type CardProps } from '@/react-pages/Prices/TransportSelector/Card';
import { identity } from 'ramda';

const StationWrapper = styled(SpaceBetween)`
  margin-top: ${tk('spacing_xs')}!important;
  display: inline-flex;
  align-items: center;
`;

export const BusCard = ({
  id,
  departureDate,
  arrivalDate,
  route,
  stationName,
  price,
  setSelected,
  isSelected,
}: CardProps) => {
  return (
    <ListItem.Root>
      <CardControl id={id} onClick={setSelected ? () => setSelected(id) : identity} isSelected={isSelected} />
      <ListItem.Content>
        <SpaceBetween direction="y" spacing={tk('spacing_2xs')}>
          <ListItem.Label>{`${departureDate.time}  - ${arrivalDate.time}`}</ListItem.Label>
          <TravelRoute {...route} />
          {stationName && (
            <StationWrapper direction="x" spacing={tk('spacing_2xs')}>
              <Icon glyph="IconBusFront" />
              <Typography $variant="body-sm">{stationName}</Typography>
            </StationWrapper>
          )}
        </SpaceBetween>
      </ListItem.Content>
      <CardTrailing price={price} />
    </ListItem.Root>
  );
};

const CardWrapper = styled.div`
  display: flex;
  align-items: center;

  background: ${tk('color_semantic_bg')};
  border: solid 2px ${tk('color_semantic_border_active')};
  border-radius: ${tk('radius_large')};
  box-shadow: ${tk('shadow_md_bottom')};
  padding: ${tk('spacing_md')};
`;

export const BusCardMobile = ({ departureDate, arrivalDate, route, stationName, price }: CardProps) => {
  return (
    <CardWrapper>
      <ListItem.Content>
        <SpaceBetween direction="y" spacing={tk('spacing_2xs')}>
          <ListItem.Label>{`${departureDate.time}  - ${arrivalDate.time}`}</ListItem.Label>
          <TravelRoute {...route} />
          {stationName && (
            <StationWrapper direction="x" spacing={tk('spacing_2xs')}>
              <Icon glyph="IconBusFront" />
              <Typography $variant="body-sm">{stationName}</Typography>
            </StationWrapper>
          )}
        </SpaceBetween>
      </ListItem.Content>
      <CardTrailing price={price} />
    </CardWrapper>
  );
};
